/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1LocationCountriesMutationRequest,
  PostApiV1LocationCountriesMutationResponse,
  PostApiV1LocationCountries400,
  PostApiV1LocationCountries401,
  PostApiV1LocationCountries409,
  PostApiV1LocationCountries500,
} from "../../types/locationCountryController/PostApiV1LocationCountries.ts";

function getPostApiV1LocationCountriesUrl() {
  const res = { method: "POST", url: `/api/v1/location/countries` as const };
  return res;
}

/**
 * @description Cria um novo país e a respectiva tradução no idioma corrente. A sigla e o nome devem ser únicos. **(Requer Authorization para autenticação)**
 * @summary Criar país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries}
 */
export async function postApiV1LocationCountries(
  data?: PostApiV1LocationCountriesMutationRequest,
  config: Partial<RequestConfig<PostApiV1LocationCountriesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1LocationCountriesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountries400
      | PostApiV1LocationCountries401
      | PostApiV1LocationCountries409
      | PostApiV1LocationCountries500
    >,
    PostApiV1LocationCountriesMutationRequest
  >({
    method: "POST",
    url: getPostApiV1LocationCountriesUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
